<hyperscene-menu *ngIf="!(sceneOnly$ | async) && !(viewerMode$ | async)"></hyperscene-menu>
<div
  class="content"
  [class.content--scene-only]="sceneOnly$ | async"
  [class.content--viewer]="viewerMode$ | async"
  [class.content--scrollable]="scrollableMode$ | async"
>
  <router-outlet></router-outlet>
</div>
